import React, { useEffect } from "react";
import { useToaster } from "../../../context/toaster";
import "./styles.css";

const Toaster = () => {
  const { messages, removeMessage } = useToaster();

  useEffect(() => {
    const timers = messages.map((message) => {
      // count words in the message text
      const wordCount = message.text.trim().split(/\s+/).length;

      // 1 second per word, with a minimum of 2 seconds
      const delay = Math.max(wordCount * 1000, 2000);

      return setTimeout(() => {
        removeMessage(message.id);
      }, delay);
    });

    return () => timers.forEach((timer) => clearTimeout(timer));
  }, [messages, removeMessage]);

  return (
    <div className="toaster-container">
      {messages.map((message) => (
        <div key={message.id} className={`toaster ${message.type}`}>
          {message.text}
          <button onClick={() => removeMessage(message.id)}>X</button>
        </div>
      ))}
    </div>
  );
};

export default Toaster;
